<script>
  export default {
    name: 'dashboard-screen-manager'
  }
</script>

<template>
  <section>
    <router-link to="/screens" class="text-muted small float-right mt-1">View offline devices &gt;</router-link>
    <h5>Screen Manager</h5>

    <div class="screen-manager card">
      <b-container fluid>
        <b-row class="icons">
          <b-col sm="12" md="6" class="on">
            <div class="icon">
              <img src="/img/dashboard/screen_on.png" srcset="/img/dashboard/screen_on@2x.png 2x" alt="">
            </div>

            <h1 class="total">37</h1>
            <p class="total-label text-primary">Online</p>
          </b-col>
          <b-col sm="12" md="6">
            <div class="icon">
              <img src="/img/dashboard/screen_off.png" srcset="/img/dashboard/screen_off@2x.png 2x" alt="">
            </div>

            <h1 class="total">3</h1>
            <p class="total-label text-muted">Offline</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <h2>Add More Licenses</h2>
            <p class="mb-4">
              Ready to add your network of screens? <br>
              Purchase more screen licenses here.
            </p>

            <b-button variant="primary mb-3">Add New Licenses</b-button>

            <p class="text-muted small">Licenses in use 40 / 40</p>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </section>
</template>

<style src="./DashboardScreenManager.scss" lang="scss" scoped></style>
